import styled from "styled-components"

export const FooterDiv = styled.footer`
  width: 100%;
  margin: ${props => (props.topMargin ? props.topMargin : 150)}px 0 20px 0;
  padding: 5px 10px;
  border-top: 1px solid #c4cace;
  font-size: 14px;
  line-height: 24px;
  color: #adb1b5;
  font-weight: 400;
`

export const LeftSection = styled.div`
  float: left;
  text-align: left;
  padding: 15px 0 15px 10px;

  @media (max-width: 800px) {
    padding: 13px 0 0 10px;
  }
`

export const RightSection = styled.div`
  float: right;
  text-align: right;
  padding: 13px 10px 15px 0;

  @media (max-width: 800px) {
    float: left;
    text-align: left;
    padding: 0 10px 15px 0;
  }
`

export const FooterLink = styled.a`
  color: #adb1b5;
  ${props => props.leftMargin && "margin-left: 30px;"}
  ${props =>
    props.rightMargin &&
    "margin-right: 30px;"}
  border-bottom: 1px dotted #adb1b5;
  text-decoration: none;

  @media (max-width: 800px) {
    margin-left: 10px;
  }
`

export const Separator = styled.span`
  display: inline-block;
  color: #adb1b5;

  @media (max-width: 800px) {
    display: none;
  }
`

export const RightText = styled.span`
  margin-left: 30px;
  display: inline-block;

  @media (max-width: 800px) {
    margin-left: 10px;
  }
`

export const Spacer = styled.span`
  @media (max-width: 800px) {
    display: none;
  }
`
